import {getTimestampNow} from "../../../util/Util";
import {
    deleteAutoRetrieverDeviceDetails,
    fetchAutoRetrieverDeviceDetails,
    setAutoRetrieverDeviceDetails, startMockTestForAutoRetriever,
    updateAutoRetrieverDeviceDetails, updateAutoRetrieverDeviceMac, updateAutoRetrieverMonitoringDetails
} from "../network/AutoRetrieverDeviceNetworkAPI";

export const AutoRetrieverDeviceOverviewReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
            fetchAutoRetrieverDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAutoRetrieverDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "UPDATE_MONITORING_DATA":
            updateAutoRetrieverMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAutoRetrieverDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "START_MOCK_TEST":
            startMockTestForAutoRetriever(action.data.dispatcher, action.data.mac, action.data.showCustomAlert)
            return {...state, loadingOverview: true}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/reducer/AutoRetrieverDeviceOverviewReducer.js